import template   from './document-consent.html'
import controller from './document-consent.controller'
import './document-consent.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/document-consent/document-consent.component.js